var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Column } from "react-vcomponents";
import { GetMapObject } from "Store/firebase/mapObjects";
import { Observer } from "vwebapp-framework";
import { store } from "Store";
import { ToolUI } from "./Tool";
import { MapObjectUI } from "../MapObjectUI";
import { MapObjectUI_Overlay } from "../MapObjectUI_Overlay";
let MoveObject = class MoveObject extends ToolUI({}, {}) {
    render() {
        const targetObject = GetMapObject(store.main.write.tools.moveObject.targetObject);
        if (targetObject == null)
            return React.createElement("div", null);
        const splitAt = 110;
        return (React.createElement(Column, null));
    }
    UpdateNewPos(newPos) {
        const targetObject = GetMapObject(store.main.write.tools.moveObject.targetObject);
        this.move_newPos = newPos;
        this.MapScene.Update();
        this.MapScene.UpdateMapObjectUI(targetObject._key); // re-render map-object-ui for selected obj, causing pos-change to be visible
    }
    /*RenderInScene() {
        let {targetObject} = this.props;
        return this.move_newPos &&
            <MapObjectUI obj={targetObject.Extended({position: this.move_newPos})} mapScene={this.MapScene} worldViewArea={this.MapScene.WorldViewArea()}/>;
    }*/
    RenderForObject(obj, extraInfo) {
        const targetObject = GetMapObject(store.main.write.tools.moveObject.targetObject);
        if (obj == targetObject && this.move_newPos) {
            extraInfo.cancelNormalRender = true;
            return React.createElement(MapObjectUI, { obj: targetObject.Extended({ position: this.move_newPos }), mapScene: this.MapScene, worldViewArea: this.MapScene.WorldViewArea() });
        }
        return null;
    }
    RenderForObject_Overlay(obj, extraInfo) {
        const targetObject = GetMapObject(store.main.write.tools.moveObject.targetObject);
        if (obj == targetObject && this.move_newPos) {
            extraInfo.cancelNormalRender = true;
            return React.createElement(MapObjectUI_Overlay, { obj: targetObject.Extended({ position: this.move_newPos }), mapScene: this.MapScene, worldViewArea: this.MapScene.WorldViewArea() });
        }
        return React.createElement("div", null);
    }
};
MoveObject = __decorate([
    Observer
], MoveObject);
export { MoveObject };
